import { createSelector } from 'reselect';
import { getProfileData } from './getProfileData';

const empty = [];

export const getPacks = createSelector(getProfileData, (data) => {
	return data?.pack || empty;
});
